import { render, staticRenderFns } from "./FormationTabContent.vue?vue&type=template&id=9a7c70ba&"
import script from "./FormationTabContent.vue?vue&type=script&lang=js&"
export * from "./FormationTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports